export const adminInitialState = {
  isLoggedIn: false,
  accessToken: null,
  userDetails: null
};

export const usersInitialState = {
  isLoading: true,
  value: [],
  index: 0,
  limit: 10,
  totalCount: 0,
  filteredCount: 0,
  search: "",
  filters: {
    approved: null,
    deleted: false,
    reported: false,
    new_post: true
  }
};

export const communitiesInitialState = {
  isLoading: true,
  value: [],
  index: 0,
  limit: 10,
  totalCount: 0,
  search: "",
  filters: {
    approved: null,
    new_community: true,
    reported: false
  }
};

export const postsInitialState = {
  isLoading: true,
  value: [],
  filters: {
    fromDate: "",
    toDate: "",
    new_post: true,
    edited_post: false,
    approved: null,
    reported: false,
    isPinned: false,
  },
  index: 0,
  limit: 10,
  totalCount: 0
};

export const jobsInitialState = {
  isLoading: true,
  value: [],
  filters: {
    fromDate: "",
    toDate: "",
    approved: null,
    new_job: true,
    reported: false
  },
  index: 0,
  limit: 10,
  totalCount: 0,
  search: ""
};

export const rentalsInitialState = {
  isLoading: true,
  value: [],
  filters: {
    fromDate: "",
    toDate: "",
    approved: null,
    reported: false,
    new_rental: true
  },
  index: 0,
  limit: 10,
  totalCount: 0,
  search: ""
};
export const businessInitialState = {
  isLoading: true,
  value: [],
  fromDate: "",
  toDate: "",
  index: 0,
  limit: 10,
  totalCount: 0,
  filters: {
    approved: null,
    new_bizz: true,
    reported: false
  },
  search: ""
};
export const easyexitInitialState = {
  isLoading: true,
  value: [],
  fromDate: "",
  toDate: "",
  index: 0,
  limit: 10,
  totalCount: 0,
  filters: {
    approved: null,
    new_easyexit: true,
    reported: false
  },
  search: ""
};
export const artistInitialState = {
  isLoading: true,
  value: [],
  fromDate: "",
  toDate: "",
  index: 0,
  limit: 10,
  totalCount: 0,
  filters: {
    approved: null,
    new_artist: true,
    reported: false,
    verified: null,
    spotlighted: null
  },
  search: ""
};

export const castingcallInitialState = {
  isLoading: true,
  value: [],
  fromDate: "",
  toDate: "",
  index: 0,
  limit: 10,
  totalCount: 0,
  filters: {
    approved: null,
    new_castingcall: true,
    reported: false
  },
  search: ""
};

export const gigInitialState = {
  isLoading: true,
  value: [],
  fromDate: "",
  toDate: "",
  index: 0,
  limit: 10,
  totalCount: 0,
  filters: {
    approved: null,
    new_gig: true,
    reported: false
  },
  search: ""
};

export const teamInitialState = {
  isLoading: true,
  value: [],
  fromDate: "",
  toDate: "",
  index: 0,
  limit: 10,
  totalCount: 0,
  filters: {
    verified: null,
    approved: null,
    reported: false
  },
  search: ""
};

export const servicesInitialState = {
  isLoading: true,
  value: [],
  totalCount: 0
};

export const combinedInitialState = {
  admin: adminInitialState,
  users: usersInitialState,
  communities: communitiesInitialState,
  posts: postsInitialState,
  jobs: jobsInitialState,
};

export const stateToBePersisted = ["admin"];
